export default __webpack_public_path__ + "cf08b8a2d2e29092c9719d23d6255bee.svg";